export enum FaultSortingSourceEnum
{
    None = 0,
    Layout = 1,
    Passed = 2,
    LayoutWithoutGrouping = 3
}
